"use strict";

/*
 * Der Stoerer: ein Kasten mit Neuigkeiten, der sich zuklappen laesst.
 *
 * Am 2026-08-31 von jQuery auf natives JavaScript umgeschrieben.
 *
 * Der Kasten startet AUFGEKLAPPT (2026-09-17). Gemerkt wird deshalb das
 * ZUklappen, in sessionStorage - es gilt fuer die laufende Sitzung und nicht
 * darueber hinaus. Bis zum 2026-09-17 war es umgekehrt: er startete zu, und
 * gemerkt wurde das Aufklappen.
 */

document.addEventListener("DOMContentLoaded", () => {
    const offen = document.querySelectorAll(".interferer-opened");
    const zu = document.querySelectorAll(".interferer-closed");

    if (offen.length === 0 && zu.length === 0) {
        return;
    }

    const setzen = (elemente, klasse, an) => {
        elemente.forEach((el) => el.classList.toggle(klasse, an));
    };

    document.querySelectorAll(".interferer-btn-close").forEach((knopf) => {
        knopf.addEventListener("click", () => {
            setzen(offen, "hide", true);
            setzen(zu, "hide", false);
            setzen(zu, "d-none", false);
            try {
                sessionStorage.setItem("interferer", "zu");
            } catch (e) {
                /* Im privaten Fenster wirft sessionStorage. Dann eben nicht merken. */
            }
        });
    });

    /*
     * Nicht der Knopf selbst horcht, sondern der Kasten zwei Ebenen darueber -
     * so oeffnet ein Klick irgendwo auf dem zugeklappten Streifen. Vorher stand
     * hier $(".interferer-btn-open").parent().parent(); deshalb darf sich an
     * der Verschachtelung in Interferer.html nichts aendern.
     */
    document.querySelectorAll(".interferer-btn-open").forEach((knopf) => {
        const kasten = knopf.parentElement && knopf.parentElement.parentElement;
        if (!kasten) {
            return;
        }
        kasten.addEventListener("click", () => {
            setzen(offen, "hide", false);
            setzen(zu, "hide", true);
            try {
                sessionStorage.removeItem("interferer");
            } catch (e) {
                /* siehe oben */
            }
        });
    });

    /*
     * Der Kasten startet aufgeklappt - so gewuenscht am 2026-09-17. Zugeklappt
     * wird nur, wenn der Besucher das in dieser Sitzung schon getan hat.
     *
     * Der Schluessel traegt den Wert "zu", und das Aufklappen loescht ihn. So
     * bleibt der Anfangszustand der aus dem Markup, auch wenn aus einer
     * frueheren Sitzung noch der alte Wert "offen" im Speicher liegt: der ist
     * nicht "zu", also wird nicht zugeklappt.
     */
    let warZu = false;
    try {
        warZu = sessionStorage.getItem("interferer") === "zu";
    } catch (e) {
        warZu = false;
    }

    if (warZu) {
        setzen(offen, "hide", true);
        setzen(zu, "hide", false);
    }
});
